import { Col, Row } from 'react-bootstrap';
import { CHANGELOG_DOCS_URL } from '@/config';
import moment from 'jalali-moment';
import logo from '@/assets/img/icon-144x144.png';
import { useGetLatestChangelogQuery } from '@/app/common/api/changelogApi';
import ChildrensTooltip from '../common/ChildrensTooltip';
import DataLoadError from '@/components/errors/DataLoadError';

const Footer = () => {
  const { data, isError, isFetching, refetch } = useGetLatestChangelogQuery();
  const changelogUrl = data?.url ?? CHANGELOG_DOCS_URL;

  return (
    <footer className="footer mb-n1">
      <Row className="justify-content-between align-items-center align-items-md-start text-center fs--1 mt-4 mb-3">
        <Col xs="auto">
          <p className="mb-0 text-600">
            <img src={logo} className="m-1" width={24} height={24} />
            <span className="d-md-inline d-none">{`میزفا تولز - ابزاری با کیفیت جهانی برای ایرانی‌ها (۱۳۹۹ - ${moment(new Date()).locale('fa').year()} )`}</span>
            <span className="d-none d-sm-inline-block mx-1"> | </span>
            <a href="https://mizfa.tools/">Mizfa Tools</a>
          </p>
        </Col>
        <Col xs="auto" className="pe-8 pt-1">
          {isError ? (
            <DataLoadError
              compact
              onRetry={() => refetch()}
              isRetrying={isFetching}
            />
          ) : (
            <ChildrensTooltip placement="top" html={data?.date_fa ?? ''}>
              <a
                href={changelogUrl}
                target="_blank"
                rel="noreferrer noopener"
                className="mb-0 text-600"
              >
                v{data?.version ?? ''}
              </a>
            </ChildrensTooltip>
          )}
        </Col>
      </Row>
    </footer>
  );
};

export default Footer;
